export const solarize = {
  name: 'solarize',
  shader: `precision mediump float;
varying vec2 v_texCoord;
uniform sampler2D u_image;

void main() {
    vec4 color = texture2D(u_image, v_texCoord);
    vec3 solarized_rgb = abs(color.rgb - 0.5) * 2.0;
    gl_FragColor = vec4(solarized_rgb, color.a);
}`,
  uniforms: [],
};
